import styled from "styled-components";
import  Breakpoints  from "../../../styles/breakpoints";

export const LineC = styled.div`
    height:1px;

`;